import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

export function MaterialTableExportAction({ action, data, disabled }) {
    let resolvedAction = typeof action === "function" ? action(data) : action;
    if (resolvedAction && resolvedAction.action) {
        resolvedAction = resolvedAction.action(data);
    }
    if (!resolvedAction || resolvedAction.hidden) {
        return null;
    }

    const isDisabled = resolvedAction.disabled || disabled;

    function handleClick(event) {
        if (resolvedAction.onClick) {
            resolvedAction.onClick(event, data);
            event.stopPropagation();
        }
    }

    const icon = typeof resolvedAction.icon === "function"
        ? resolvedAction.icon({ ...resolvedAction.iconProps, disabled: isDisabled })
        : React.createElement(resolvedAction.icon, resolvedAction.iconProps);

    const button = (
        <IconButton
            style={{ marginLeft: 12 }}
            color="inherit"
            disabled={isDisabled}
            onClick={handleClick}
        >
            {icon}
        </IconButton>
    );

    if (!resolvedAction.tooltip) return button;

    return (
        <Tooltip title={resolvedAction.tooltip}>
            {isDisabled ? <span style={{ display: "inline-flex" }}>{button}</span> : button}
        </Tooltip>
    );
}
